/** Initial task state for the task form hook. */
import {
  emptyTaskState,
  MIN_DURATION,
} from '@/features/tasks/utils/ui/taskFormUtils';

export const buildInitialTaskFormState = (initialTask) =>
  initialTask
    ? {
        ...emptyTaskState,
        ...initialTask,
        duration: initialTask.duration || MIN_DURATION,
      }
    : { ...emptyTaskState };
